import React, { useEffect } from "react";
import { Avatar, Button, Flex, Form, Input, Space } from "antd";
// import { PictureOutlined } from "@ant-design/icons";
import { IUserInfo } from "../../../../../utilFunctions/CommonInterfaces/userInterface";
import { generateColor, getInitials } from "./CommentPost";

const { TextArea } = Input;

interface CommentInputProps {
  onSubmit: (text: string) => void;
  user: IUserInfo;
  initialValue?: string;
  buttonText?: string;
  isSubmitting?: boolean;
  onCancel?: () => void;
}

export const CommentInput: React.FC<CommentInputProps> = ({
  onSubmit,
  user,
  initialValue = "",
  buttonText = "Post",
  isSubmitting,
  onCancel,
}) => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({ comment: initialValue });
  }, [initialValue, form]);

  const onFinish = (values: any) => {
    const trimmedComment = values.comment.trim();
    onSubmit(trimmedComment);
    form.resetFields();
  };

  return (
    <Form form={form} onFinish={onFinish} style={{ marginTop: "16px" }}>
      <Flex gap="large" align="start">
        <Avatar
          style={{
            backgroundColor: generateColor(user.user_name),
            marginTop: "4px",
          }}
          src={user.avatarUrl}
          size={40}
        >
          {getInitials(user.user_name)}
        </Avatar>
        <Flex flex={1} vertical gap="small">
          <Form.Item
            name="comment"
            style={{ margin: 0, width: "100%" }}
            rules={[
              { required: true, message: "Comment cannot be empty." },
              {
                validator: (_, value) => {
                  if (value && value.trim() === "") {
                    return Promise.reject(
                      new Error("Comment cannot be just whitespace.")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <TextArea
              placeholder="Write a comment..."
              style={{
                width: "100%",
                borderRadius: "10px",
                border: "1px solid #e8e8e8",
                padding: "12px 16px",
                fontSize: "14.5px",
                backgroundColor: "#fafafa",
                transition: "all 0.3s",
              }}
              autoSize={{ minRows: 2, maxRows: 6 }}
              className="comment-textarea"
            />
          </Form.Item>
          <Flex justify="flex-end" align="center" style={{ marginTop: "8px" }}>
            <Space>
              {onCancel && (
                <Button
                  onClick={onCancel}
                  type="text"
                  style={{ borderRadius: "8px" }}
                >
                  Cancel
                </Button>
              )}
              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                style={{
                  borderRadius: "8px",
                  paddingLeft: "24px",
                  paddingRight: "24px",
                  fontWeight: 500,
                }}
              >
                {buttonText}
              </Button>
            </Space>
          </Flex>
        </Flex>
      </Flex>
    </Form>
  );
};
